import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { getNewApiClient } from "./client";
import { AuthenticationService } from "./authentication";

export class PerspectiveApiService {
  private static instance: PerspectiveApiService;
  private client: ApolloClient<NormalizedCacheObject>;

  private constructor(client: ApolloClient<NormalizedCacheObject>) {
    this.client = client;
  }

  public static getInstance(reset: boolean = false): PerspectiveApiService {
    if (!PerspectiveApiService.instance || reset) {
      if (PerspectiveApiService.instance) {
        PerspectiveApiService.instance.client.stop();
      }
      PerspectiveApiService.instance = new PerspectiveApiService(
        getNewApiClient()
      );

      // Set up token refresh callback to recreate client when token changes
      AuthenticationService.setOnTokenRefresh(() => {
        console.info(
          "Token refreshed, recreating PerspectiveApiService client"
        );
        PerspectiveApiService.instance.reconnect();
      });
    }
    return PerspectiveApiService.instance;
  }

  getClient(): ApolloClient<NormalizedCacheObject> {
    return this.client;
  }

  reset(): void {
    this.client.resetStore();
    this.reconnect();
  }
  reconnect(): void {
    this.client.stop();
    this.client = PerspectiveApiService.getInstance(true).getClient();
  }
  stop(): void {
    this.client.resetStore();
    this.client.stop();
  }
}
